<template>
  <img
    :class="$style.confirmAppointmentLogo"
    src="@/base/assets/logos/ista-logo.svg"
  >
</template>

<style module>
.confirmAppointmentLogo {
    height: 40px;
    margin-top: var(--space-xxs);

    @media screen and (min-width: 740px) {
        height: 60px;
        margin-bottom: var(--space-xxs);
    }
}
</style>
